import "@/App.css";
import Portfolio from "@/pages/Portfolio";

function App() {
  return (
    <div className="App">
      <Portfolio />
    </div>
  );
}

export default App;
